import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'li3-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})

export class CheckboxComponent {
  @Input() isChecked: boolean;
  @Input() title: string;
  @Input() tooltip: string;
  @Input() testId: string;
  @Output() changed = new EventEmitter();

  constructor() { }

  isItemChecked(value: boolean) {
    return value ? '1' : '0';
  }

  onChange(value: boolean) {
    this.isChecked = !value;
    this.changed.emit(!value);
  }
}
